<div class="page-shell page-shell--canvas">
  <div class="dc-wrapper">
    <div class="dc-layout">
      <div class="dc-section dc-sidebar">
        <div class="dc-section__header">
          <h2 class="dc-section__title">
            {{
              (readOnly
                ? "digitalCards.title"
                : "digitalCards.templatesTitle"
              ) | translate
            }}
          </h2>
        </div>
        <div class="dc-section__content">
          @if (!readOnly && selectedProfile && isTemplate(selectedProfile)) {
            <div
              class="dc-employee-picker-wrap"
              [hidden]="!employeePickerReady"
            >
              <app-digital-card-employee-picker
                [value]="previewEmployee"
                [templateContextId]="pickerTemplateContextId"
                [preferredUserId]="preferredPreviewUserId"
                (valueChange)="onPreviewEmployeeChange($event)"
                (initialSelectionResolved)="onEmployeePickerInitialResolved()"
              ></app-digital-card-employee-picker>
            </div>
          }
          @if (!listBusy && !readOnly) {
            <button type="button" class="dc-add-card" (click)="addCard()">
              <mat-icon>add</mat-icon>
              <span>{{ "digitalCards.addTemplate" | translate }}</span>
            </button>
          }
          <div class="dc-list">
            @if (!listBusy) {
              @for (profile of profiles; track profile.profileId) {
                <button
                  type="button"
                  class="dc-list-item"
                  [class.dc-list-item--selected]="isSelected(profile)"
                  (click)="selectCard(profile)"
                >
                  <div class="dc-list-meta">
                    <div class="dc-list-name-row">
                      <span class="dc-list-name">{{
                        profile.displayName || profile.profileId
                      }}</span>
                      @if (profile.isDefault) {
                        <span class="dc-list-default">
                          <mat-icon>check</mat-icon>
                          {{
                            "digitalCards.default.unsetDefaultButton" | translate
                          }}
                        </span>
                      }
                    </div>
                    <span
                      class="dc-list-status"
                      [class.dc-list-status--pub]="
                        profile.status === 'published' &&
                        !isTemplateSyncing(profile)
                      "
                      [class.dc-list-status--sync]="isTemplateSyncing(profile)"
                      >{{ getStatusLabel(profile.status, profile) }}</span
                    >
                  </div>
                </button>
              }
            }
          </div>
          @if (listBusy) {
            <div class="dc-list-syncing dc-list-syncing--sidebar" aria-busy="true">
              <mat-spinner diameter="28"></mat-spinner>
            </div>
          }
        </div>
      </div>

      <div class="dc-section dc-main">
        @switch (mainPhase) {
          @case ("boot") {
            <div class="dc-section__content dc-empty-wrap">
              <div class="dc-empty-state dc-empty-state--syncing">
                <mat-spinner diameter="36"></mat-spinner>
                <p>{{ "digitalCards.syncing" | translate }}</p>
              </div>
            </div>
          }
          @case ("empty") {
            <div class="dc-section__content dc-empty-wrap">
              <div class="dc-empty-state">
                <mat-icon>contact_page</mat-icon>
                @if (!readOnly) {
                  <button mat-raised-button color="primary" (click)="addCard()">
                    <mat-icon>add</mat-icon>
                    {{ "digitalCards.addFirstTemplate" | translate }}
                  </button>
                }
              </div>
            </div>
          }
          @default {
            @let cardTitle =
              selectedProfile!.displayName || selectedProfile!.profileId;
            @let isDeleting = deletingProfileId === selectedProfile!.profileId;
            @if (mainReady) {
              <div class="dc-section__header dc-main-header">
                <div class="dc-title-row">
                  <h2 class="dc-section__title">{{ cardTitle }}</h2>
                  @if (!readOnly) {
                    @if (selectedProfile!.isDefault) {
                      <button
                        type="button"
                        class="dc-title-default-button dc-title-default-button--active"
                        disabled
                        [attr.aria-label]="
                          'digitalCards.default.unsetDefaultButton' | translate
                        "
                      >
                        <mat-icon>check</mat-icon>
                        {{
                          "digitalCards.default.unsetDefaultButton" | translate
                        }}
                      </button>
                    } @else {
                      <button
                        type="button"
                        class="dc-title-default-button"
                        [disabled]="
                          defaultSettingProfileId === selectedProfile!.profileId
                        "
                        (click)="setDefault(selectedProfile!)"
                        [attr.aria-label]="
                          'digitalCards.default.setDefaultButton' | translate
                        "
                      >
                        @if (
                          defaultSettingProfileId === selectedProfile!.profileId
                        ) {
                          <mat-spinner
                            diameter="14"
                            class="dbc1-spinner dbc1-spinner--sm"
                          ></mat-spinner>
                        } @else {
                          <mat-icon>star_outline</mat-icon>
                        }
                        {{
                          "digitalCards.default.setDefaultButton" | translate
                        }}
                      </button>
                    }
                  }
                </div>
                <div class="dc-actions">
                  @if (canShowEntryLink()) {
                    <button
                      type="button"
                      class="action-btn"
                      [attr.aria-label]="
                        'digitalCards.copyEntryLink' | translate
                      "
                      [disabled]="entryLinkBusy"
                      (click)="openEntryDialog()"
                    >
                      @if (entryLinkBusy) {
                        <mat-spinner
                          diameter="16"
                          class="dbc1-spinner dbc1-spinner--sm"
                        ></mat-spinner>
                      } @else {
                        <mat-icon>link</mat-icon>
                      }
                      {{ "digitalCards.entryAction" | translate }}
                    </button>
                  }
                  @if (!readOnly) {
                    <button
                      type="button"
                      class="action-btn"
                      (click)="editCard(selectedProfile!)"
                    >
                      <mat-icon>edit</mat-icon>
                      {{ "edit" | translate }}
                    </button>
                  }
                  @if (shareTarget) {
                    <button
                      type="button"
                      class="action-btn"
                      (click)="openShare()"
                    >
                      <mat-icon>share</mat-icon>
                      {{ "digitalCards.share" | translate }}
                    </button>
                    <button
                      type="button"
                      class="action-btn"
                      (click)="openCardUrl()"
                    >
                      <mat-icon>launch</mat-icon>
                      {{ "digitalCards.openCard" | translate }}
                    </button>
                  }
                  @if (!readOnly && profiles.length > 1) {
                    <button
                      type="button"
                      class="action-btn action-btn--danger dc-action-delete"
                      (click)="deleteCard(selectedProfile!, $event)"
                      [disabled]="isDeleting"
                    >
                      @if (isDeleting) {
                        <mat-spinner
                          diameter="18"
                          class="dbc1-spinner dbc1-spinner--sm"
                        ></mat-spinner>
                      } @else {
                        <mat-icon>delete_outline</mat-icon>
                      }
                      {{
                        (isDeleting ? "digitalCards.deleting" : "delete")
                          | translate
                      }}
                    </button>
                  }
                </div>
              </div>
            }
            <div class="dc-section__content dc-preview-content">
              @if (showIframe) {
                <div
                  class="dc-preview-frame-wrap"
                  [class.dc-preview-frame-wrap--pending]="!mainReady"
                  [attr.aria-hidden]="!mainReady"
                >
                  <iframe
                    [src]="previewIframeSrc"
                    class="dc-preview-iframe"
                    [title]="cardTitle"
                    (load)="onPreviewIframeLoad()"
                  ></iframe>
                </div>
              }
              @if (!mainReady) {
                <div class="dc-preview-content-center">
                  <div class="dc-empty-state dc-empty-state--syncing">
                    <mat-spinner diameter="36"></mat-spinner>
                    <p>{{ "digitalCards.syncing" | translate }}</p>
                  </div>
                </div>
              } @else if (showEmptyEmployees) {
                <div class="dc-preview-content-center">
                  <div class="dc-empty-state">
                    <mat-icon>badge</mat-icon>
                    <p>{{ "digitalCards.noEmployeeCards" | translate }}</p>
                    <p class="dc-empty-state__hint">
                      {{ "digitalCards.syncHint" | translate }}
                    </p>
                  </div>
                </div>
              } @else if (showNotPublished) {
                <div class="dc-preview-content-center">
                  <div class="dc-empty-state">
                    <mat-icon>badge</mat-icon>
                    <p>{{ "digitalCards.notPublished" | translate }}</p>
                    @if (!readOnly) {
                      <button
                        mat-raised-button
                        color="primary"
                        (click)="editCard(selectedProfile!)"
                      >
                        <mat-icon>edit</mat-icon>
                        {{ "edit" | translate }}
                      </button>
                    }
                  </div>
                </div>
              }
            </div>
          }
        }
      </div>
    </div>
  </div>
</div>
